import { render } from "./ExpensesTable.vue?vue&type=template&id=b7964996"
import script from "./ExpensesTable.vue?vue&type=script&lang=js"
export * from "./ExpensesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__